"use client";

import { ReturnTypeWithPagination, timeAsMilliseconds, Vehicle, VehicleGetDTO } from "@alba-cars/common-modules";
import { useInfiniteQuery, useSuspenseInfiniteQuery } from "@tanstack/react-query";

import { fetchCars } from "@/lib/api/client/fetchCars";
import { baseQuery, constructInfiniteQueryData } from "@/lib/utils";

export const useInfiniteCarsQuery = (
  baseQueryOptions: Omit<VehicleGetDTO, "page" | "toPlain" | "validate">,
  pageSize: number = 20,
  initialData?: ReturnTypeWithPagination<Vehicle[]>,
) => {
  const queryKey = [
    "infinite-cars",
    [
      {
        ...baseQueryOptions,
        options: {
          ...baseQuery.options,
          // ...(baseQueryOptions?.options?.sort && { sort: baseQueryOptions?.options?.sort }),
          sort: baseQueryOptions?.options?.sort ? baseQueryOptions.options.sort : {},
          limit: pageSize,
        },
      },
    ],
  ];

  return useInfiniteQuery({
    queryKey: queryKey,
    queryFn: async ({ pageParam = 1 }) => {
      const result = await fetchCars({
        ...baseQueryOptions,
        options: {
          ...baseQuery.options,
          // ...(baseQueryOptions?.options?.sort && { sort: baseQueryOptions?.options?.sort }),
          sort: baseQueryOptions?.options?.sort ? baseQueryOptions.options.sort : {},
          page: pageParam as number,
          limit: pageSize,
        },
      });
      return result;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      const totalPages = Math.ceil((lastPage?.data?.total ?? 0) / pageSize);
      const nextPage = allPages?.length + 1;
      return nextPage <= totalPages ? nextPage : undefined;
    },
    // staleTime: timeAsMilliseconds({ hours: 1 }), // Set staleTime to 0 to mark data as immediately stale
    staleTime: timeAsMilliseconds({ minutes: 5 }),
    gcTime: timeAsMilliseconds({ minutes: 5 }),
    refetchInterval: timeAsMilliseconds({ hours: 1 }),
    refetchOnWindowFocus: false,
    refetchOnMount: !!initialData,
    notifyOnChangeProps: ["isLoading", "data", "isFetchingNextPage"],
    initialData: initialData ? constructInfiniteQueryData(initialData) : undefined, // Use placeholderData instead of initialData
  });
};
